import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routeNames } from "../../constants/routeNames";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import "./SimplePages.css";

export const AlreadyEntered = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location?.state?.redirected) {
      navigate(routeNames.LANDING);
    } else {
      setTitle("SORRY!");
      setLoading(false);
    }
  }, []);

  return (
    <div className="simple-content ">
      <h2 className="simple-content-title">You’ve already entered today.</h2>
      <p className="simple-content-description">Please try again tomorrow.</p>
    </div>
  );
};
